var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"techTree"},[_c('h2',[_c('router-link',{attrs:{"to":_vm.object.url()}},[_vm._v(_vm._s(_vm.object.name))])],1),_vm._v(" "),_c('h3',[_vm._v("Tech Tree")]),_vm._v(" "),_c('TechTreeView',{attrs:{"object":_vm.object}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4388d9a4","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/TechTree.vue
// module id = 128
// module chunks = 0